import type {useApplyMidYearPriceAdjustmentMutation} from '@dms/api/new-vehicle';

import type {AdjustmentValues} from '../components/PriceAdjustmentDialog';

type PriceAdjustmentRequestBody = Parameters<
  ReturnType<typeof useApplyMidYearPriceAdjustmentMutation>[0]
>[0]['priceAdjustmentRequestBody'];

/** Everything the API needs except `previewOnly`; also the identity a preview was made for. */
export const toAdjustmentRequest = (
  values: AdjustmentValues,
  version: number
): Omit<PriceAdjustmentRequestBody, 'previewOnly'> => ({
  kind: values.kind,
  value: values.direction === 'down' && values.value !== '0.00' ? `-${values.value}` : values.value,
  scope: values.scope,
  resourceIds: values.scope === 'all' ? [] : values.resourceIds,
  note: values.note || undefined,
  nextPricelistVersionLabel: values.nextVersion,
  effectiveFrom: values.effectiveFrom || undefined,
  version,
});
